import { useEffect } from "react";
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getClassStudents } from "../../redux/sclassRelated/sclassHandle";
import { Paper, Box, Typography, Button, CircularProgress } from '@mui/material';
import { styled } from '@mui/system';
import TableTemplate from "../../components/TableTemplate";

const primaryTeal = '#008080';
const accentGold = '#FFD700';
const hoverTeal = '#006666';
const darkTeal = '#004d4d';

const GoldButton = styled(Button)(({ theme }) => ({
    backgroundColor: accentGold,
    color: darkTeal,
    fontWeight: 'bold',
    padding: '10px 20px',
    borderRadius: '8px',
    transition: 'all 0.3s ease',
    '&:hover': {
        backgroundColor: '#FFC107',
        transform: 'translateY(-2px)',
        boxShadow: `0 4px 15px rgba(255, 215, 0, 0.4)`,
    },
}));

const TealButton = styled(Button)(({ theme }) => ({
    backgroundColor: primaryTeal,
    color: '#ffffff',
    fontWeight: 'bold',
    padding: '10px 20px',
    borderRadius: '8px',
    transition: 'all 0.3s ease',
    '&:hover': {
        backgroundColor: hoverTeal,
        transform: 'translateY(-2px)',
        boxShadow: `0 4px 15px rgba(0, 128, 128, 0.4)`,
    },
}));

const TeacherClassDetails = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { sclassStudents, loading, error, getresponse } = useSelector((state) => state.sclass);
    const { currentUser } = useSelector((state) => state.user);
    const classID = currentUser.teachSclass?._id;
    const subjectID = currentUser.teachSubject?._id;

    useEffect(() => {
        dispatch(getClassStudents(classID));
    }, [dispatch, classID]);

    if (error) {
        console.log(error);
    }

    const studentColumns = [
        { id: 'name', label: 'Name', minWidth: 170 },
        { id: 'rollNum', label: 'Roll Number', minWidth: 100 },
    ];

    const studentRows = sclassStudents.map((student) => {
        return {
            name: student.name,
            rollNum: student.rollNum,
            id: student._id,
        };
    });

    const StudentsButtonHaver = ({ row }) => {
        return (
            <TealButton
                variant="contained"
                onClick={() => navigate("/Teacher/class/student/" + row.id)}
            >
                View
            </TealButton>
        );
    };

    return (
        <>
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                    <CircularProgress sx={{ color: primaryTeal }} />
                </Box>
            ) : (
                <>
                    <Typography variant="h4" align="center" gutterBottom sx={{ color: primaryTeal, fontWeight: 'bold', marginBottom: '24px' }}>
                        Class Details
                    </Typography>
                    {getresponse ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
                            <Typography variant="h6" sx={{ color: darkTeal }}>
                                No Students Found
                            </Typography>
                        </Box>
                    ) : (
                        <>
                            {/* Buttons Section */}
                            <Box sx={{ 
                                display: 'flex', 
                                justifyContent: { xs: 'center', sm: 'flex-end' }, 
                                marginTop: '16px', 
                                gap: '10px',
                                flexDirection: { xs: 'column', sm: 'row' },
                                alignItems: { xs: 'center', sm: 'flex-start' },
                            }}>
                                <GoldButton
                                    variant="contained"
                                    onClick={() => navigate(`/Teacher/class/student/attendance/${classID}/${subjectID}`)}
                                >
                                    Take Attendance
                                </GoldButton>
                                <GoldButton
                                    variant="contained"
                                    onClick={() => navigate(`/Teacher/class/student/marks/${classID}/${subjectID}`)}
                                >
                                    Provide Marks
                                </GoldButton>
                            </Box>

                            <Paper sx={{ 
                                width: '100%', 
                                overflow: 'hidden', 
                                marginTop: '24px', 
                                backgroundColor: '#ffffff',
                                boxShadow: '0 4px 20px rgba(0, 128, 128, 0.2)',
                                borderRadius: '12px',
                            }}>
                                <Typography variant="h5" gutterBottom sx={{ padding: '16px', color: primaryTeal, fontWeight: 'bold' }}>
                                    Students List:
                                </Typography>
                                {Array.isArray(sclassStudents) && sclassStudents.length > 0 &&
                                    <TableTemplate buttonHaver={StudentsButtonHaver} columns={studentColumns} rows={studentRows} />
                                }
                            </Paper>
                        </>
                    )}
                </>
            )}
        </>
    );
};

export default TeacherClassDetails;